export default () => {
  const ctaClickabele = Array.from(document.querySelectorAll('.js-cta-clickable'));
  if (ctaClickabele.length) {
    return import(/* webpackChunkName: "ctaAsLink" */ '../components/cta-as-link')
      .then(({ default: CtaLink }) => new CtaLink())
      .catch((error) => `CTA as link : ${error}`);
  }
  return null;
};
